@use '@design/design-tokens/typography/typography' as *;

.styledModalRoot {
  [data-modal-container] {
    width: 95%;
    max-width: 555px;
    background: var(--background-soft);
    overflow-y: visible;
  }
}

.customSelectorWrapper {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.modalTitleWrapper {
  display: flex;
  gap: 8px;
}

.customStyledInputWrapper {
  display: flex;
  gap: 8px;
  width: 50%;
  align-items: center;

  span {
    color: var(--text-soft);
    @include typography-v2-body-sm;
  }
}
